import FlameIcon from '@/bundle/shared/components/banner/images/FlameIcon.svg?react';
import BannerArrowIcon from '@/bundle/shared/components/banner/images/BannerArrowIcon.svg?react';
import { useNavigate } from 'react-router';
import { getMasterAdminBillingPath } from '@/bundle/_MasterAdmin/_BillingPage/path/path';
import { useUser } from '@/context/userContext';
import { CompletePaymentBlock } from '@/bundle/shared/components/banner/styles';
import { Banner } from '@/components/Banner/Banner';
import { COLORS } from '@/styles/colors';

export const SubscriptionSuspendedBanner = () => {
  const navigate = useNavigate();
  const { isMasterAdminRole } = useUser();

  return (
    <Banner background={COLORS.red[100]} icon={<FlameIcon />}>
      Your account has been moved to <b>view-only mode</b> due to unpaid subscription renewal. Please{' '}
      {isMasterAdminRole ? (
        <CompletePaymentBlock onClick={() => navigate(getMasterAdminBillingPath())}>
          complete your payment
          <BannerArrowIcon />
        </CompletePaymentBlock>
      ) : (
        <>
          <b>contact the Master Admin</b> of your organization.
        </>
      )}
    </Banner>
  );
};
